import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";
import { Close } from "@mui/icons-material";

const ModalInfo = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  copyButton,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9998,
      }}
      onClick={onClose}
    >
      <Grid
        container
        item
        xs={11}
        md={5}
        sx={{
          position: "relative",
          backgroundColor: "#fff",
          maxHeight: "100%",
          width: { xs: "90%", sm: "80%" },
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Grid
          item
          xs={12}
          style={{
            height: "60px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
          }}
        >
          <Grid item xs={0} style={{ marginLeft: "15px" }}>
            {/* <div className="icon-modal-info" /> */}
          </Grid>
          <Grid item xs={10}>
            <Typography
              className="color-blue-dark"
              style={{ fontSize: "18px", fontWeight: 600 }}
            >
              {title}
            </Typography>
          </Grid>
          {/* <Grid
            item
            xs={1}
            style={{
              marginRight: "15px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Close style={{ color: "#5b5b5b" }} fontSize="small" />
          </Grid> */}
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <Typography
            style={{
              padding: "10px 15px 0px 15px",
              marginTop: "20px",
            }}
            className="color-blue-dark"
          >
            {descriptionOne}
          </Typography>
          <Typography
            style={{
              padding: "0px 15px",
            }}
            className="color-blue-dark"
          >
            {descriptionTwo}
          </Typography>
        </Grid>

        <Grid container item xs={12} style={{ marginTop: "20px" }}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px",
            }}
          >
            <Button
              variant="contained"
              className="button-bg-blue"
              onClick={confirm}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                {copyButton}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ModalInfo;
